
// ── BLOQUE 1A · Rotación de mensajes ──


// ── SLIDE CLIENTES ──
(function() {
  const track = document.getElementById('slideTrack');
  if (!track) return;
  const origCards = Array.from(track.querySelectorAll('.slide-card'));
  origCards.forEach(c => track.appendChild(c.cloneNode(true)));
  let pos = 0, paused = false;
  const speed = 1.8;
  function animate() {
    if (!paused) {
      pos += speed;
      const totalWidth = origCards.reduce((acc, c) => acc + c.offsetWidth + 14, 0);
      if (pos >= totalWidth) pos = 0;
      track.style.transform = `translateX(-${pos}px)`;
    }
    requestAnimationFrame(animate);
  }
  track.addEventListener('touchstart', () => { paused = true; }, { passive: true });
  track.addEventListener('touchend', () => { setTimeout(() => paused = false, 2000); }, { passive: true });
  animate();
})();

// ── MINI FAQ PRODUCTO ──
function toggleMini(btn) {
  var body = btn.nextElementSibling;
  var chev = btn.querySelector('svg');
  var abierto = body.style.maxHeight && body.style.maxHeight !== '0px';
  if (abierto) {
    body.style.maxHeight = '0px';
    if (chev) chev.style.transform = 'rotate(0deg)';
  } else {
    body.style.maxHeight = body.scrollHeight + 'px';
    if (chev) chev.style.transform = 'rotate(180deg)';
  }
}

// ── FAQ ──
function toggleFaq(btn) {
  btn.closest('.faq-item').classList.toggle('open');
}

// ── PAQUETES / CHECKOUT ──
let selectedVariant = (window.FX_VARIANT || '');
let selectedName = (window.FX_NAME || '');
let selectedPrice = (window.FX_PRICE || '');

function fxOpenBuy(btn) {
  // Selecciona la variante elegida en el selector nativo (lo lee EasySell)
  var nativeSelect = document.querySelector('select[name="id"], input[name="id"]');
  if (nativeSelect) {
    nativeSelect.value = selectedVariant;
    nativeSelect.dispatchEvent(new Event('change', { bubbles: true }));
  }
  // Botón de EasySell COD (la app de contra entrega del usuario).
  //
  // OJO: en la página hay DOS elementos con id="es-popup-button": el del
  // carrito (.es-popup-button-drawer, que aparece antes en el documento) y
  // el del producto (.es-popup-button-product). Buscar por el id devuelve
  // el PRIMERO, o sea el del carrito, que abre el carrito vacío: ruleta sin
  // ofertas y total negativo. Hay que pedir el del producto por su clase.
  var codBtn =
    document.querySelector('.es-popup-button-product') ||
    document.querySelector('[id="es-popup-button"]:not(.es-popup-button-drawer)') ||
    document.querySelector('easysell-form [data-buy]') ||
    document.querySelector('[class*="es-popup-button"]:not(.es-popup-button-drawer)');
  if (codBtn) { codBtn.click(); return; }
  // Respaldo: carrito nativo de Shopify
  var form = document.querySelector('form[action*="/cart/add"]');
  if (form) {
    var idInput = form.querySelector('input[name="id"]') || document.createElement('input');
    idInput.type = 'hidden'; idInput.name = 'id'; idInput.value = selectedVariant;
    if (!idInput.parentNode) form.appendChild(idInput);
    var submitBtn = form.querySelector('button[type="submit"], button[name="add"]');
    if (submitBtn) { submitBtn.click(); return; }
    form.submit();
  }
}


// ── PALETA ──
// Los colores viven en :root (assets/fx.css) y cada plantilla los redefine
// en snippets/fx-paleta.liquid. El JS los lee de ahi en vez de repetirlos.
function fxColor(nombre, respaldo) {
  try {
    var v = getComputedStyle(document.documentElement).getPropertyValue(nombre).trim();
    return v || respaldo;
  } catch (e) { return respaldo; }
}

// ── VIDEO INLINE + AUTO THUMBNAIL ──
function ugcDrawThumb(idx) {
  var vid = document.getElementById('ugcVid' + idx);
  var canvas = document.getElementById('ugcCanvas' + idx);
  if (!vid || !canvas) return;
  var thumb = document.getElementById('ugcThumb' + idx);
  var dpr = window.devicePixelRatio || 1;
  var w = thumb.offsetWidth || 160;
  var h = thumb.offsetHeight || 260;
  canvas.width = w * dpr;
  canvas.height = h * dpr;
  canvas.style.width = w + "px";
  canvas.style.height = h + "px";
  try {
    var ctx = canvas.getContext('2d');
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = "high";
    ctx.drawImage(vid, 0, 0, canvas.width, canvas.height);
    var data = ctx.getImageData(0, 0, 10, 10).data;
    var sum = 0;
    for (var i = 0; i < data.length; i++) sum += data[i];
    if (sum < 100) throw new Error('black frame');
    canvas.style.display = 'block';
  } catch(e) {
    canvas.style.display = 'none';
    thumb.style.background = 'linear-gradient(160deg, ' + fxColor('--acento', '#e0a100') + ' 0%, #151515 100%)';
  }
}

function ugcInitThumb(idx) {
  var vid = document.getElementById('ugcVid' + idx);
  if (!vid) return;
  var attempts = 0;
  function trySeek() {
    attempts++;
    var seekTime = [1.0, 2.0, 0.5, 3.0][attempts - 1] || 1.0;
    vid.currentTime = seekTime;
  }
  vid.addEventListener('loadeddata', function() { trySeek(); });
  vid.addEventListener('loadedmetadata', function() { trySeek(); });
  vid.addEventListener('seeked', function() {
    var canvas = document.getElementById('ugcCanvas' + idx);
    var ctx = canvas ? canvas.getContext('2d') : null;
    if (!ctx) return;
    var thumb = document.getElementById('ugcThumb' + idx);
    var dpr = window.devicePixelRatio || 1;
    var w = thumb.offsetWidth || 160;
    var h = thumb.offsetHeight || 260;
    canvas.width = w * dpr;
    canvas.height = h * dpr;
    canvas.style.width = w + "px";
    canvas.style.height = h + "px";
    try {
      ctx.drawImage(vid, 0, 0, canvas.width, canvas.height);
      var data = ctx.getImageData(0, 0, 20, 20).data;
      var sum = 0;
      for (var i = 0; i < data.length; i++) sum += data[i];
      if (sum < 200 && attempts < 4) {
        setTimeout(trySeek, 300);
        return;
      }
      if (sum < 200) throw new Error('black');
      canvas.style.display = 'block';
    } catch(e) {
      canvas.style.display = 'none';
      thumb.style.background = 'linear-gradient(160deg, ' + fxColor('--acento', '#e0a100') + ' 0%, #151515 100%)';
    }
  });
  vid.load();
}

document.addEventListener('DOMContentLoaded', function() {
  var total = document.querySelectorAll('.ugc-thumb').length || 5;
  for (var i = 0; i < total; i++) ugcInitThumb(i);
});

function playVidInline(idx) {
  var thumb = document.getElementById('ugcThumb' + idx);
  if (thumb.classList.contains('playing')) return;
  var total = document.querySelectorAll('.ugc-thumb').length || 5;
  for (var i = 0; i < total; i++) (function(i) {
    var t = document.getElementById('ugcThumb' + i);
    if (t && i !== idx) {
      t.classList.remove('playing');
      var v = document.getElementById('ugcVid' + i);
      if (v) { v.pause(); v.currentTime = 0.5; v.muted = true; }
    }
  })(i);
  var vid = document.getElementById('ugcVid' + idx);
  if (!vid) return;
  thumb.classList.add('playing');
  vid.currentTime = 0;
  vid.muted = fxMutedGlobal;
  fxPaintSound(idx);
  var p = vid.play();
  if (p && p.catch) p.catch(function(){
    // si el navegador rechaza el audio, al menos que se vea
    vid.muted = true; fxPaintSound(idx); vid.play();
  });
}

// ── SONIDO ──
var fxMutedGlobal = false;
function fxPaintSound(idx) {
  var btn = document.getElementById('ugcSnd' + idx);
  var vid = document.getElementById('ugcVid' + idx);
  if (!btn || !vid) return;
  btn.innerHTML = vid.muted ? '&#128263;' : '&#128266;';
  btn.setAttribute('aria-label', vid.muted ? 'Activar el sonido' : 'Silenciar');
}
function fxToggleSound(e, idx) {
  e.stopPropagation();
  var vid = document.getElementById('ugcVid' + idx);
  if (!vid) return;
  vid.muted = !vid.muted;
  fxMutedGlobal = vid.muted;
  fxPaintSound(idx);
  if (vid.paused) { var p = vid.play(); if (p && p.catch) p.catch(function(){}); }
}

// ── YOUTUBE / VIMEO EN GRANDE ──
// Un enlace de YouTube no es un archivo de video, asi que no puede ir en
// <video src>. Se abre en su propio reproductor, a pantalla grande y con audio.
function fxPlayEmbed(idx) {
  var thumb = document.getElementById('ugcThumb' + idx);
  var src = thumb && thumb.getAttribute('data-embed');
  if (!src) return;
  fxStopAllVideos();
  var lb = document.getElementById('fxLightbox');
  var box = document.getElementById('fxLightboxBox');
  if (!lb || !box) return;
  box.innerHTML = '<iframe src="' + src + '" allow="autoplay; encrypted-media; picture-in-picture; fullscreen" allowfullscreen title="Vídeo de cliente"></iframe>';
  lb.hidden = false;
  document.body.style.overflow = 'hidden';
}
function fxCloseEmbed(e, forzar) {
  var lb = document.getElementById('fxLightbox');
  if (!lb) return;
  if (!forzar && e && e.target !== lb) return;
  if (e) e.stopPropagation();
  document.getElementById('fxLightboxBox').innerHTML = '';
  lb.hidden = true;
  document.body.style.overflow = '';
}
function fxStopAllVideos() {
  document.querySelectorAll('.ugc-vid-inline').forEach(function(v) {
    v.pause();
    var t = v.closest('.ugc-thumb');
    if (t) t.classList.remove('playing');
  });
}
document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') fxCloseEmbed(null, true);
});

function stopVidInline(e, idx) {
  e.stopPropagation();
  var thumb = document.getElementById('ugcThumb' + idx);
  var vid = document.getElementById('ugcVid' + idx);
  if (vid) { vid.pause(); vid.currentTime = 0.5; vid.muted = true; }
  thumb.classList.remove('playing');
  setTimeout(function(){ ugcDrawThumb(idx); }, 150);
}

// ── CONTADORES ──
(function() {
  var done = false;
  function runCounters() {
    if (done) return;
    done = true;
    document.querySelectorAll('.num-pct[data-target]').forEach(function(el) {
      var target = parseInt(el.getAttribute('data-target'));
      // La unidad la decide la plantilla: hay cifras en mg y en dias, no solo
      // porcentajes. Si no viene, se mantiene el % de siempre.
      var unit = el.getAttribute('data-unit');
      if (unit === null) unit = '%';
      var current = 0, inc = target / 55;
      var t = setInterval(function() {
        current = Math.min(current + inc, target);
        el.textContent = Math.round(current) + unit;
        if (current >= target) clearInterval(t);
      }, 20);
    });
  }
  function isVisible() {
    var grid = document.getElementById('numGrid');
    if (!grid) return false;
    var r = grid.getBoundingClientRect();
    return r.top < window.innerHeight && r.bottom > 0;
  }
  function onScroll() {
    if (isVisible()) { runCounters(); removeListeners(); }
  }
  function removeListeners() {
    window.removeEventListener('scroll', onScroll);
    window.removeEventListener('touchstart', onScroll);
    window.removeEventListener('touchmove', onScroll);
    window.removeEventListener('touchend', onScroll);
  }
  function init() {
    if (isVisible()) { runCounters(); return; }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('touchstart', onScroll, { passive: true });
    window.addEventListener('touchmove', onScroll, { passive: true });
    window.addEventListener('touchend', onScroll, { passive: true });
    setTimeout(function() { if (!done && isVisible()) runCounters(); }, 500);
    setTimeout(function() { if (!done && isVisible()) runCounters(); }, 1200);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

// ── ANTES/DESPUÉS CAROUSEL ──
var baCur = 0;
var baTot = (function(){ var t=document.getElementById('baTrack'); return (t && t.children.length) ? t.children.length : 1; })();
function baGoTo(i) {
  baCur = i;
  var track = document.getElementById('baTrack');
  if (track) track.style.transform = 'translateX(-' + (i * 100) + '%)';
  var dots = document.querySelectorAll('#baDots button');
  dots.forEach(function(d, j) {
    d.style.width = j === i ? '24px' : '8px';
    d.style.background = j === i ? fxColor('--acento', '#e0a100') : fxColor('--borde-suave', '#e8d29a');
  });
}
(function() {
  var el = document.getElementById('beforeAfterCarousel');
  if (!el) return;
  var sx = 0;
  el.addEventListener('touchstart', function(e) { sx = e.touches[0].clientX; }, { passive: true });
  el.addEventListener('touchend', function(e) {
    var diff = sx - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 40) baGoTo(diff > 0 ? (baCur+1)%baTot : (baCur-1+baTot)%baTot);
  }, { passive: true });
})();

// ── HERO CAROUSEL ──
var heroCurrent = 0;
// Las láminas son las fotos del producto: el número lo decide el catálogo,
// así que se cuenta en el DOM en vez de fijarlo aquí.
function heroTot() {
  var track = document.getElementById('heroTrack');
  var n = track ? track.children.length : 0;
  return n > 0 ? n : 1;
}
function heroGoTo(index) {
  var tot = heroTot();
  index = ((index % tot) + tot) % tot;
  heroCurrent = index;
  var track = document.getElementById('heroTrack');
  if (track) {
    // Cada paso avanza el ancho de un slide (90%) más su separación (8px).
    // En el último slide retrocede 10% para alinearlo al borde derecho y que se asome el anterior.
    var shift = index === tot - 1
      ? 'calc(-' + index + ' * (90% + 18px) + 10%)'
      : 'calc(-' + index + ' * (90% + 18px))';
    track.style.transform = 'translateX(' + shift + ')';
  }
  document.querySelectorAll('.hero-thumb').forEach(function(d, i) {
    d.classList.toggle('active', i === index);
  });
}
(function() {
  var el = document.getElementById('heroCarousel');
  if (!el) return;
  var startX = 0;
  el.addEventListener('touchstart', function(e) {
    startX = e.touches[0].clientX;
  }, { passive: true });
  el.addEventListener('touchend', function(e) {
    var diff = startX - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 40) {
      heroGoTo(diff > 0 ? heroCurrent + 1 : heroCurrent - 1);
    }
  }, { passive: true });
})();

// ── INGREDIENTES CAROUSEL ──
var ingCur = 0;
// El numero de laminas lo manda la seccion, no una constante: si se escribe a
// mano y sobran, el carrusel avanza a laminas que no existen y se ve en blanco.
function ingTotal() {
  var track = document.getElementById('ingTrack');
  var n = track ? track.children.length : 0;
  return n > 0 ? n : 1;
}
var ingAutoTimer = null;
var ingPaused = false;
function ingGoTo(i, userTriggered) {
  var tot = ingTotal();
  i = ((i % tot) + tot) % tot;   // nunca fuera de rango: tras la ultima vuelve a la primera
  ingCur = i;
  var track = document.getElementById('ingTrack');
  if (track) track.style.transform = 'translateX(-' + (i * 100) + '%)';
  var dots = document.querySelectorAll('#ingDots button');
  dots.forEach(function(d, j) {
    d.style.background = j === i ? fxColor('--acento', '#e0a100') : 'transparent';
  });
  if (userTriggered) ingPauseAuto();
}
function ingStartAuto() {
  if (ingAutoTimer) clearInterval(ingAutoTimer);
  ingAutoTimer = setInterval(function() {
    if (!ingPaused) ingGoTo(ingCur + 1);
  }, 5000);
}
function ingPauseAuto() {
  ingPaused = true;
  setTimeout(function() { ingPaused = false; }, 8000);
}
(function() {
  var el = document.getElementById('ingCarousel');
  if (!el) return;
  var sx = 0;
  el.addEventListener('touchstart', function(e) { sx = e.touches[0].clientX; ingPaused = true; }, { passive: true });
  el.addEventListener('touchend', function(e) {
    var diff = sx - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 40) ingGoTo(diff > 0 ? ingCur + 1 : ingCur - 1, true);
    else setTimeout(function() { ingPaused = false; }, 3000);
  }, { passive: true });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ingStartAuto);
  } else {
    ingStartAuto();
  }
})();

// ── MODAL AUTORIZACIÓN SUSCRIPCIÓN ──
var _subTargetUrl = '';
function openSubModal(e, url, planName, planPrice) {
  if (e && e.preventDefault) e.preventDefault();
  _subTargetUrl = url;
  var m = document.getElementById('subModal');
  var nameEl = document.getElementById('subModalPlanName');
  var priceEl = document.getElementById('subModalPlanPrice');
  var check = document.getElementById('subAuthCheck');
  var btn = document.getElementById('subConfirmBtn');
  if (nameEl) nameEl.textContent = planName || 'Plan';
  if (priceEl) priceEl.textContent = planPrice || '';
  if (check) check.checked = false;
  if (btn) {
    btn.disabled = true;
    btn.style.background = '#cccccc';
    btn.style.cursor = 'not-allowed';
  }
  if (m) {
    m.style.display = 'flex';
    document.body.style.overflow = 'hidden';
  }
  return false;
}
function closeSubModal() {
  var m = document.getElementById('subModal');
  if (m) {
    m.style.display = 'none';
    document.body.style.overflow = '';
  }
}
function toggleSubConfirmBtn() {
  var check = document.getElementById('subAuthCheck');
  var btn = document.getElementById('subConfirmBtn');
  if (!check || !btn) return;
  if (check.checked) {
    btn.disabled = false;
    btn.style.background = 'linear-gradient(105deg, #053f30 0%, #0a6b50 45%, #2e9d78 85%, #7cc9a9 100%)';
    btn.style.cursor = 'pointer';
    btn.style.boxShadow = '0 6px 20px rgba(138,98,0,0.35)';
  } else {
    btn.disabled = true;
    btn.style.background = '#cccccc';
    btn.style.cursor = 'not-allowed';
    btn.style.boxShadow = 'none';
  }
}
function confirmSubModal() {
  var check = document.getElementById('subAuthCheck');
  if (!check || !check.checked) return;
  var url = _subTargetUrl;
  closeSubModal();
  if (url) window.open(url, '_blank');
}
function switchToNormalPurchase() {
  closeSubModal();
  setTimeout(function() {
    if (typeof fxOpenBuy === 'function') fxOpenBuy(null);
  }, 150);
}
document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') {
    var m = document.getElementById('subModal');
    if (m && m.style.display === 'flex') closeSubModal();
    closeArcsaModal();
  }
});

// ── MODAL ARCSA ──
function openArcsaModal() {
  var m = document.getElementById('arcsaModal');
  if (m) {
    m.style.display = 'flex';
    document.body.style.overflow = 'hidden';
  }
}
function closeArcsaModal(e) {
  if (e && e.target && e.target.tagName === 'IMG') return;
  var m = document.getElementById('arcsaModal');
  if (m) {
    m.style.display = 'none';
    document.body.style.overflow = '';
  }
}

// ── PUNTOS INDICADORES DE RESEÑAS ──
(function(){
  var grid = document.querySelector('.rev-grid');
  var dots = document.getElementById('revDots');
  if (!grid || !dots) return;
  function update(){
    var idx = Math.round(grid.scrollLeft / grid.clientWidth);
    Array.prototype.forEach.call(dots.children, function(d, i){
      d.style.background = i === idx ? '#064f3b' : '#c5ddd4';
      d.style.width = i === idx ? '20px' : '8px';
      d.style.borderRadius = i === idx ? '4px' : '50%';
    });
  }
  function build(){
    var pages = Math.max(1, Math.round(grid.scrollWidth / grid.clientWidth));
    dots.innerHTML = '';
    for (var i = 0; i < pages; i++){
      (function(i){
        var d = document.createElement('button');
        d.setAttribute('aria-label', 'Ir al grupo de reseñas ' + (i + 1));
        d.style.cssText = 'width:8px;height:8px;border-radius:50%;border:none;padding:0;cursor:pointer;background:#c5ddd4;transition:all 0.25s;';
        d.onclick = function(){ grid.scrollTo({ left: i * grid.clientWidth, behavior: 'smooth' }); };
        dots.appendChild(d);
      })(i);
    }
    update();
  }
  grid.addEventListener('scroll', function(){ requestAnimationFrame(update); }, { passive: true });
  window.addEventListener('resize', build);
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', build); } else { build(); }
})();


// ── STICKY: aparece solo después del CTA principal del hero ──
(function(){
  var bar = document.getElementById('stickyAtc');
  var ancla = document.querySelector('.btn-hero');
  if (!bar || !ancla) return;
  function chequear(){
    var r = ancla.getBoundingClientRect();
    if (r.bottom < 0) { bar.classList.add('show'); }
    else { bar.classList.remove('show'); }
  }
  window.addEventListener('scroll', function(){ requestAnimationFrame(chequear); }, { passive: true });
  window.addEventListener('resize', chequear);
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', chequear); } else { chequear(); }
})();

